import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FileUploader } from 'ng2-file-upload';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import { PartnersService } from '../services/partners.service';

@Component({
  selector: 'app-paratnerscategory',
  templateUrl: './paratnerscategory.component.html',
  styleUrls: ['./paratnerscategory.component.scss']
})
export class ParatnerscategoryComponent implements OnInit {

  public uploader: FileUploader = new FileUploader({});
  partnerForm:FormGroup;
  categoryList:any = [];

  cancellationReason: boolean;
  cancellationArray:any = [];

  cancellationReasonDelete: boolean;
  cancellationArrayDelete:any = [];

  name = ""
  description= ""

  constructor(private partnersService: PartnersService,
    private formBuilder: FormBuilder) { }

  ngOnInit(): void {
    this.partnerForm = this.formBuilder.group({
      name: '',
      description: ''
    });
    this.partnersService.getPartnersCategory().then((res:any) => {
      console.log(res.partner_categories)
      for (let i = 0; i < res.partner_categories.length; i++) {
        this.categoryList.push({ 
          id: res.partner_categories[i].id, 
          name: res.partner_categories[i].name,
          description: res.partner_categories[i].description,
          position: res.partner_categories[i].position,
         });
      }
      console.log(this.categoryList)
    })

  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.categoryList, event.previousIndex, event.currentIndex);
    console.log(event.previousIndex+1)
    console.log(event.currentIndex+1)
    this.partnersService.arrangeCategory(event.previousIndex+1, event.currentIndex+1).then((res) => {
      console.log(res)
    })
  }

  addCategory(){
    var formData: FormData = new FormData();

    formData.append("name", this.partnerForm.get('name').value);
    formData.append("description", this.partnerForm.get('description').value);
   
    this.partnersService.addPartnersCategory(formData).then((res:any) => {
      if(res.success) {
        console.log(res)
        this.categoryList.push({
          id: res.partner_category.id, 
          name: res.partner_category.name,
          description: res.partner_category.description,
          position: res.partner_category.position,
        })
        this.partnerForm.reset()
      }
    })
    .catch((error) => {
      console.log(error)
    })
  }

  removeCat(){
    this.partnersService.deletePartnersCategory(this.cancellationArrayDelete.id).then((res) => {
      console.log(res)
      let filteredArray = this.categoryList.filter(o =>o.id !== this.cancellationArrayDelete.id)
        this.categoryList = filteredArray
        this.cancellationReasonDelete = false;
    })
  }

  // updateCat(category){
  //   console.log(category)
  // }

  showCancellation(array) {
    
    this.cancellationReason = true;
    this.cancellationArray = array;
    this.name = this.cancellationArray.name
    this.description = this.cancellationArray.description
    console.log(this.cancellationArray)
    console.log("NAME ON OPEN MODAL:  ", this.name)
    console.log("DESC ON OPEN MODAL:  ", this.description)
  }

  hideCancellation() {
    this.cancellationReason = false;
  }

  showDelete(id) {
    this.cancellationReasonDelete = true;
    this.cancellationArrayDelete.id = id;
    console.log(this.cancellationArrayDelete.id)
  
  }
  
  hideDelete() {
    this.cancellationReasonDelete = false;
  }

  update(){
    // let namee
    // let descriptionn
    // console.log(this.cancellationArray)
    // console.log(this.name, this.description)
    console.log("NAME ON UPDATE:  ", this.name)
    console.log("DESC ON UPDATE:  ", this.description)
    if (this.name == ""){ this.name = this.cancellationArray.name; console.log("REPLACED NAME BY:  ", this.cancellationArray.name)}
    if (this.description == ""){ this.description = this.cancellationArray.description; console.log("REPLACED DESC BY:  ", this.cancellationArray.description)}
    // console.log("MODIFIED NAME", this.cancellationArray.name)
    // console.log("MODIFIED DESC", this.cancellationArray.description)
    console.log("NAME SENT:  ", this.name)
    console.log("DESC SENT:  ", this.description)
    // console.log(this.name)
    // console.log(this.description)
    this.partnersService.updatePartnersCategory(this.cancellationArray.id, this.name, this.description).then((res:any) => {

      console.log(res)
      this.cancellationReason = false;
      for (let i=0; i<this.categoryList.length; i++){
        if(this.categoryList[i].id == this.cancellationArray.id){
          this.categoryList[i].name = this.name;
          this.categoryList[i].description = this.description;
        }
    
     
      }
    })
    // this.name = this.cancellationArray.name
    // this.description = this.cancellationArray.description
  }

}
